/*
  德语
*/
export default {
  billing: {}
}
